export class TicketUpdateModel {
  id: number;
  statusId: number;
  orderId: number;
  plantId: number;
}
